import React, { Component } from "react";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import Modal from 'react-modal'
import HeaderVentas from "../../components/header.ventas";

const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', margin: '0 auto', marginBottom: 20, }), }
const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };

class CortesModulePage extends Component {
  constructor(props) {
    super(props);

    this.goToGeneral = this.goToGeneral.bind(this)
    this.state = {
      goToGeneral: this.goToGeneral,
    }
  }

  componentDidMount() {
    this.goToGeneral()
    this.props.onRef(this)
  }

  render() {
    const { isOpenCorte, isOpenAbono, isOpenViewInfoCortes, optInfoCortes, arrHistorialCortes, arrHistorialVentas } = this.props.subState
    const { type } = this.props.initState.signedIn

    const arrOptions = [
      {id_motivo: 1, label: 'Retiro de efectivo', value: 'Retiro de efectivo'},
      {id_motivo: 3, label: 'A solicitud de oficina', value: 'A solicitud de oficina'},
      {id_motivo: 4, label: 'Pago a proveedor', value: 'Pago a proveedor'},
    ]


    return (
      <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', marginTop: 0, }}>
        {/* Principal  */}
        <>
          <HeaderVentas initState={ this.props.initState } initsetState={ (param) => this.props.initsetState(param) } />

          <p className="regVentaPage__productGeneral" style={{ padding: 0, }}>Resumen de ventas y movimientos</p>
          <input type={"date"}
            value={this.props.subState.fecha_resumen_cajero}
            onChange={(event) => {this.props.subSetState({fecha_resumen_cajero: event.target.value}) }}
            style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
          />
          <p className={'btn btn-primary'} onClick={() => { this.goToGeneral() }}>Generar</p>

          <Row>
            <Col>
              <p className="regVentaPage__product" style={{ padding: 0, }}>Total cobrado</p>
              <p className="regVentaPage__productPrice" style={{ padding: 0, }}>${ this.number_format(arrHistorialVentas.total, 2) }</p>
            </Col>
            <Col>
              <p className="regVentaPage__product" style={{ padding: 0, }}>Egresos</p>
              <p className="regVentaPage__productPrice" style={{ padding: 0, }}>${ this.number_format(arrHistorialCortes.total, 2) }</p>
            </Col>
            <Col>
              <p className="regVentaPage__product" style={{ padding: 0, }}>Totales en caja</p>
              <p className="regVentaPage__productPrice" style={{ padding: 0, }}>${ this.number_format(((arrHistorialVentas.total - arrHistorialCortes.total) + arrHistorialCortes.apertura), 2) }</p>
            </Col>
          </Row>

          {
            type === 2 ? (
              <Row>
                <Col>
                  <Row>
                    <Col>
                      <p
                        style={{ padding: '5px 14px', cursor: 'pointer', textAlign: 'center', background: '#2980b9', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', }}
                        onClick={ () => { this.onAddCorteCaja(1) }} className="regVentaPage__title"
                      >Registrar egresos de caja</p>
                    </Col>
                    <Col>
                      <p
                        style={{ padding: '5px 14px', cursor: 'pointer', textAlign: 'center', background: '#2980b9', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', }}
                        onClick={ () => { this.onAddAbono(1) }} className="regVentaPage__title"
                      >Registrar abono</p>
                    </Col>
                  </Row>
                  <hr />

                  <Row>
                    <Col>
                      <p
                        style={{ padding: '5px 14px', marginTop: 10, cursor: 'pointer', textAlign: 'center', background: '#2980b9', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', }}
                        onClick={ () => { this.viewInfoCorte(1) }} className="regVentaPage__title"
                      >Corte del día</p>
                    </Col>
                    <Col>
                      <p
                        style={{ padding: '5px 14px', marginTop: 10, cursor: 'pointer', textAlign: 'center', background: '#2980b9', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', }}
                        onClick={ () => { this.viewInfoCorte(2) }} className="regVentaPage__title"
                      >Imprimir desglose de venta</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            ) : null
          }

          <hr />

          <p style={{ fontWeight: 600, fontSize: '1.1rem', textTransform: 'uppercase', margin: '20px 0', }}>Mis cortes de hoy</p>
          {
            arrHistorialCortes.list.map((t,e) => (
              <Row
                onClick={ () => {  } }
                key={`ws_list_compra_${e}`}
                style={{ width: '100%', margin: '0 auto', marginTop: 10, }}
                className="regVentaPage__content"
              >
                <div className="regVentaPage__separator"></div>
                <Col className="regVentaPage__listProduct">
                  <p style={{ color: t.status === 0 ? '#F4AA35' : '#333' }}>{t.nombre}</p>
                  <p>{t.hora}</p>
                  <p className="regVentaPage__productInfo" style={{ paddingBottom: '20px !important' }}>
                    {
                      t.status === 1
                      ? 'El administrador aún no ha verificado este corte.'
                      : 'Este corte ya se encuentra autorizado.'
                    }
                  </p>
                  <p className="regVentaPage__productInfo" style={{ paddingBottom: '20px !important', marginTop: 20, color: '#000', }}>{t.observacion}</p>
                </Col>
                <Col className="regVentaPage__listPrices" xs={7}>
                  <p className="lprices__amount">${ this.number_format( t.valor, 2) }</p>
                </Col>
              </Row>
            ))
          }

          <hr />

          <p style={{ fontWeight: 600, fontSize: '1.1rem', textTransform: 'uppercase', margin: '20px 0', }}>Mis movimientos de hoy</p>
          {
            arrHistorialVentas.list.map((t,e) => (
              <Row
                onClick={ () => {  } }
                key={`ws_list_compra_${e}`}
                style={{ width: '100%', margin: '0 auto', marginTop: 10, }}
                className="regVentaPage__content"
              >
                <div className="regVentaPage__separator"></div>
                <Col className="regVentaPage__listProduct">
                  <p style={{ color: t.status === 0 ? '#F4AA35' : '#333' }}>{t.nombre}</p>
                  {
                    t.forma_pago < 5 ? (
                      <p>Venta</p>
                    ) : null
                  }
                  {
                    t.forma_pago === 5 ? (
                      <p>Traspaso a sucursal</p>
                    ) : null
                  }
                  {
                    t.forma_pago === 6 ? (
                      <p>Merma</p>
                    ) : null
                  }
                  {
                    t.status === 2 ? (
                      <p>Sin pagar</p>
                    ) : null
                  }
                </Col>
                <Col className="regVentaPage__listPrices" xs={7}>
                  <p className="lprices__amount">${ this.number_format( (t.venta_pesos) , 2) }</p>
                  <p className="lprices__amount" style={{ fontWeight: 800, fontSize: 12, }}>P. unitario: ${this.number_format((t.venta_pesos / t.venta_kg), 2)}</p>
                  <p className="lprices__kg">{t.venta_kg} KG</p>
                </Col>
              </Row>
            ))
          }


          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={isOpenCorte}
            onRequestClose={() => { this.props.subSetState({isOpenCorte: false}) }}
            style={customStyles}
            contentLabel=""
            >
            <div className="modalBody__operador">
              <Row className="modalBody__corte"> 
                <Col>
                  <h4>Motivo del corte</h4>
                  <Select
                    onChange={(item) => this.props.subSetState({ id_motivo: item.id_motivo })}
                    placeholder={'Elige un motivo'}
                    options={arrOptions}
                    styles={customStylesOption}
                  />

                  <input type="text" placeholder="Ingresa el monto a retirar..." onChange={ (event) => { this.props.subSetState({valorCorte: event.target.value}) } } />

                  {
                    this.props.subState.id_motivo === 4 ||this.props.subState.id_motivo === 1 ? (
                      <textarea
                        value={this.props.subState.observacionCorte}
                        placeholder={
                          this.props.subState.id_motivo === 4
                          ? 'Por favor ingresa la información del proveedor pagado.'
                          : 'Por favor ingresa una observación del parcial.'
                        }
                        onChange={(e) => { this.props.subSetState({ observacionCorte: e.target.value }) }}
                        style={{ border: '1px solid #f3f3f3', background: '#f3f3f3', borderRadius: 4, minHeight: 200, resize: 'none', width: '90%', margin: '0 auto', display: 'block', }}></textarea>
                    ) : null
                  }

                  <p style={{ textAlign: 'right', fontWeight: 800, marginRight: '20px', }}>Total ${this.number_format(this.props.subState.valorCorte, 2)}</p>

                  <p
                    style={{ padding: '5px 14px', cursor: 'pointer', textAlign: 'center', background: '#2980b9', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', }}
                    onClick={ () => { this.onAddCorteCaja(2) }} className="regVentaPage__title"
                  >Registrar</p>

                </Col>
              </Row>
            </div>
          </Modal>

          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={isOpenAbono}
            onRequestClose={() => { this.props.subSetState({isOpenAbono: false}) }}
            style={customStyles}
            contentLabel=""
            >
            <div className="modalBody__operador">
              <Row className="modalBody__corte"> 
                <Col>
                  <h4>Detalles del abono</h4>

                  <input type="text" placeholder="Ingresa el monto abonado..." onChange={ (event) => { this.props.subSetState({valorAbono: event.target.value}) } } />
                  <textarea
                    value={this.props.subState.observacionAbono}
                    placeholder={ 'Por favor ingresa el nombre o número de ticket de abono.' }
                    onChange={(e) => { this.props.subSetState({ observacionAbono: e.target.value }) }}
                    style={{ border: '1px solid #f3f3f3', background: '#f3f3f3', borderRadius: 4, minHeight: 200, resize: 'none', width: '90%', margin: '0 auto', display: 'block', }}
                  ></textarea>
                  <p style={{ textAlign: 'right', fontWeight: 800, marginRight: '20px', }}>Total ${this.number_format(this.props.subState.valorAbono, 2)}</p>
                  <p
                    style={{ padding: '5px 14px', cursor: 'pointer', textAlign: 'center', background: '#2980b9', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', }}
                    onClick={ () => { this.onAddAbono(2) }} className="regVentaPage__title"
                  >Registrar</p>

                </Col>
              </Row>
            </div>
          </Modal>

          <Modal
            overlayClassName="Overlay__aplicaciones"
            isOpen={isOpenViewInfoCortes}
            onRequestClose={() => { this.props.subSetState({isOpenViewInfoCortes: false}) }}
            style={this.getStyleModal('isOpenViewInfoCortes')}
            contentLabel=""
            >
            <div className="modalBody__operador">
              <Row className="modalBody__corte"> 
                <Col>
                  <h4>Corte del día</h4>
                  { optInfoCortes === 1 ? this.makeInfoCorteDia() : null }
                  { optInfoCortes === 2 ? this.makeInfoDesgloseVentas() : null }

                </Col>
              </Row>
            </div>
          </Modal>
        </>

      </div>
    )
  }

  makeInfoCorteDia() {
    const { arrDataCorte } = this.props.subState

    return (
      <>
        <Row>
          <Col><p>ABONOS:</p></Col>
          <Col><p>${this.number_format(arrDataCorte.abonos,2)}</p></Col>
        </Row>
        <Row>
          <Col><p>APERTURAS:</p></Col>
          <Col><p>${this.number_format(arrDataCorte.aperturas,2)}</p></Col>
        </Row>
        <Row>
          <Col><p>CREDITO:</p></Col>
          <Col><p>${this.number_format(arrDataCorte.credito,2)}</p></Col>
        </Row>
        <Row>
          <Col><p>DEBITO:</p></Col>
          <Col><p>${this.number_format(arrDataCorte.debito,2)}</p></Col>
        </Row>
        <Row>
          <Col><p>EFECTIVO:</p></Col>
          <Col><p>${this.number_format(arrDataCorte.efectivo,2)}</p></Col>
        </Row>
        <Row>
          <Col><p>FOLIO FIN:</p></Col>
          <Col><p>{this.number_format(arrDataCorte.folio_end,0)}</p></Col>
        </Row>
        <Row>
          <Col><p>FOLIO INICIO:</p></Col>
          <Col><p>{this.number_format(arrDataCorte.folio_start,0)}</p></Col>
        </Row>
        <Row>
          <Col><p>MERMA:</p></Col>
          <Col><p>${this.number_format(arrDataCorte.merma,2)}</p></Col>
        </Row>
        <Row>
          <Col><p>NOTA_CREDITO:</p></Col>
          <Col><p>${this.number_format(arrDataCorte.nota_credito,2)}</p></Col>
        </Row>
        <Row>
          <Col><p>PARCIALES:</p></Col>
          <Col><p>${this.number_format(arrDataCorte.parciales,2)}</p></Col>
        </Row>
        <Row>
          <Col><p>PROVEEDORES:</p></Col>
          <Col><p>${this.number_format(arrDataCorte.proveedores,2)}</p></Col>
        </Row>
        <Row>
          <Col><p>TOTAL:</p></Col>
          <Col><p>${this.number_format(arrDataCorte.total,2)}</p></Col>
        </Row>
        <Row>
          <Col><p>TRASPASO:</p></Col>
          <Col><p>${this.number_format(arrDataCorte.traspaso,2)}</p></Col>
        </Row>

        <button onClick={() => { this.onAddCorteDia(1) }} className={'btn btn-primary'}>Imprimir</button>
      </>
    )
  }

  makeInfoDesgloseVentas() {
    return null
  }

  goToGeneral() {
    //Cargar información del día
    const { fecha_resumen_cajero, } = this.props.subState
    const { id_sucursal, type } = this.props.initState.signedIn
    let data = {
      fecha_resumen_cajero,
      date: fecha_resumen_cajero,
      id_vendedor: this.props.initState.id_vendedor,
      id_sucursal,
      type,
    }
    //Get local not sync files
    fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=getLocalVentas", this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {
      this.props.subSetState({ localVentas: response })
      //Get resumen from server
      fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getResumenVentasByDay", this.headersPOST({...data}))
      .then(response => response.json())
      .then((response) => {
        this.props.subSetState({
          arrHistorialVentas: response.ventas,
          arrHistorialCortes: response.cortes,
          numVentaGlobal: this.pad(response.numVentaGlobal, 5),
        })
      })
    }).catch((error) => {
      fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getResumenVentasByDay", this.headersPOST({...data}))
      .then(response => response.json())
      .then((response) => {
        this.props.subSetState({
          arrHistorialVentas: response.ventas,
          arrHistorialCortes: response.cortes,
          numVentaGlobal: this.pad(response.numVentaGlobal, 5),
        })
      })
    });
  }

  onAddCorteCaja(opt) {
    if(opt === 1) {
      this.props.subSetState({isOpenCorte: true})
    } else if(opt === 2) {
      const { id_motivo, valorCorte, date, observacionCorte, fecha_resumen_cajero } = this.props.subState

      if(id_motivo === -1 || valorCorte === 0) {
        alert('Se requiere de un monto y un motivo de corte.')
        return false
      }

      if(id_motivo === 4 && observacionCorte.trim() === '') {
        alert('Por favor ingresa la información del proveedor pagado.')
        return false
      }

      //Register
      let data = {
        id_corte: this.uniqid(),
        id_vendedor: this.props.initState.id_vendedor,
        date: fecha_resumen_cajero,
        id_motivo,
        valorCorte,
        observacionCorte,
        printerActive: this.props.initState.printerActive,
      }

      this.props.subSetState({ isOpenCorte: false, })

      //Se registra en local
      fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setRegisterNewCorte", this.headersPOST({...data}))
      .then(response => response.json())
      .then((response) => {
        alert('Corte realizado con éxito')
        this.props.subSetState({
          isOpenCorte: false,
          id_motivo: -1,
          valorCorte: 0,
          observacionCorte: '',
        })

        fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setRegisterNewCorte", this.headersPOST({ ...data, }))
        .then(response0 => response0.json())
        .then((response0) => {
          fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setRemoveLocalVenta", this.headersPOST({file: response.file}))
          .then(response1 => response1.json())
          .then((response1) => {
            this.props.subSetState({
              isOpenCorte: false,
              id_motivo: -1,
              valorCorte: 0,
              observacionCorte: '',
            }, this.goToGeneral)
            setTimeout(() => { }, 1000)
          })
        }).catch((error) => {
          this.props.subSetState({
            isOpenCorte: false,
            id_motivo: -1,
            valorCorte: 0,
            observacionCorte: '',
          }, this.goToGeneral)
        });
      }).catch((error) => {
        this.props.subSetState({
          isOpenCorte: false,
          id_motivo: -1,
          valorCorte: 0,
          observacionCorte: '',
        })

        fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setRegisterNewCorte", this.headersPOST({ ...data, }))
        .then(response0 => response0.json())
        .then((response0) => {
          this.goToGeneral()
          alert('Corte realizado con éxito')
        })
      })

    }
  }

  onAddAbono(opt) {
    if(opt === 1) {
      this.props.subSetState({isOpenAbono: true})
    } else if(opt === 2) {
      const { valorAbono, date, observacionAbono, fecha_resumen_cajero } = this.props.subState

      if(observacionAbono.trim() === '' || valorAbono === 0) {
        alert('Por favor el monto y nombre del cliente o número de ticket.')
        return false
      }

      //Register
      let data = {
        id_corte: this.uniqid(),
        id_vendedor: this.props.initState.id_vendedor,
        date: fecha_resumen_cajero,
        id_motivo: 5,
        valorCorte: (valorAbono * -1),
        observacionCorte: observacionAbono,
        printerActive: this.props.initState.printerActive,
      }

      this.props.subSetState({ isOpenAbono: false, })

      //Se registra en local
      fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setRegisterNewCorte", this.headersPOST({...data}))
      .then(response => response.json())
      .then((response) => {
        alert('Abono realizado con éxito')
        this.props.subSetState({
          isOpenAbono: false,
          id_motivo: -1,
          valorAbono: 0,
          observacionAbono: '',
        })

        fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setRegisterNewCorte", this.headersPOST({ ...data, }))
        .then(response0 => response0.json())
        .then((response0) => {
          fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setRemoveLocalVenta", this.headersPOST({file: response.file}))
          .then(response1 => response1.json())
          .then((response1) => {
            this.props.subSetState({
              isOpenAbono: false,
              id_motivo: -1,
              valorAbono: 0,
              observacionAbono: '',
            }, this.goToGeneral)
            setTimeout(() => { }, 1000)
          })
        }).catch((error) => {
          this.props.subSetState({
            isOpenAbono: false,
            id_motivo: -1,
            valorAbono: 0,
            observacionAbono: '',
          }, this.goToGeneral)
        });
      }).catch((error) => {
        this.props.subSetState({
          isOpenAbono: false,
          id_motivo: -1,
          valorAbono: 0,
          observacionAbono: '',
        })

        fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setRegisterNewCorte", this.headersPOST({ ...data, }))
        .then(response0 => response0.json())
        .then((response0) => {
          this.goToGeneral()
          alert('Abono realizado con éxito')
        })
      })

    }
  }

  viewInfoCorte(opt) {
    if(opt === 2) {
      this.onAddCorteDia(opt)
      return false
    }
    this.props.subSetState({ optInfoCortes: opt, isOpenViewInfoCortes: true, })
    const { fecha_resumen_cajero } = this.props.subState
    const { signedIn } = this.props.initState
    const data = {
      fecha_resumen_cajero,
      id_sucursal: signedIn.id_sucursal,
      id_usuario: signedIn.id_usuario,
      opt,
    }

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getCorteDelDia", this.headersPOST({ ...data, }))
    .then(response => response.json())
    .then((response) => {
      this.props.subSetState({ arrDataCorte: response.data })
    })

    // if(opt === 1) {
    //   //Vista corte
    // } else if(opt === 2) {
    //   //Vista desglose
    // }

  }

  onAddCorteDia(opt) {
    const { fecha_resumen_cajero } = this.props.subState
    const { signedIn } = this.props.initState
    const data = {
      fecha_resumen_cajero,
      id_sucursal: signedIn.id_sucursal,
      id_usuario: signedIn.id_usuario,
      opt,
    }

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getCorteDelDia", this.headersPOST({ ...data, }))
    .then(response0 => response0.json())
    .then((response0) => {
      response0 = {
        ...response0,
        fecha: moment(fecha_resumen_cajero).format('DD/MM/YYYY'),
        nombre_cajero: (signedIn.nombre + ' ' + signedIn.apellidos),
        printerActive: this.props.initState.printerActive,
      }

      fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=printCorteDelDia", this.headersPOST({ ...response0 }))
      .then(response1 => response1.json())
      .then((response1) => {
        alert('Corte realizado con éxito')
        // this.props.subSetState({isOpenCorte: false}, this.goToGeneral)
        // setTimeout(() => { }, 1000)
      })
    }).catch((error) => {
      alert('Ocurrió un error al generar el corte. Contacta al administrador.')
    });
  }
  

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

  getStyleModal(opt) {
    if(opt === 'isOpenViewInfoCortes') {
      return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '50%',height: '70%',} };
    }

    return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }


}

export default withRouter(CortesModulePage)